import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the shape of the account info collected in the first onboarding step
interface AccountInfo {
  firstName: string;
  lastName: string;
  companyName: string;
  companyWebsite: string;
}

// Onboarding state holds the account info and a flag for completion
interface OnboardingState {
  accountInfo: AccountInfo | null;
  completed: boolean;
}

const initialState: OnboardingState = {
  accountInfo: null,
  completed: false,
};

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    saveAccountInfo: (state, action: PayloadAction<AccountInfo>) => {
      state.accountInfo = action.payload;
    },
    completeOnboarding: (state) => {
      state.completed = true;
    },
  },
});

export const { saveAccountInfo, completeOnboarding } = onboardingSlice.actions;
export default onboardingSlice.reducer;
